export const defaultEventDuration = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

export enum EventCoversEnum {
	Image1 = 'a6422c9b-b7c9-4f16-80ac-c94db04a370a',
	Image2 = '0bb057c6-0acd-49f0-a4a2-565de3375246',
	Image3 = '35fb7910-4e87-473b-998d-9c20e4f28a08',
	Image4 = 'a4693a2b-5992-43bd-a600-023c907410e1',
	Image5 = '8a9cdfa3-078d-4738-8b8d-8eb138166c66',
	Image6 = 'afb5454b-026d-4d0b-b30e-1c1e16213ff7',
	Image7 = '446034be-8bb6-4e52-94f1-b8793cdc0baa',
	Image8 = '405de6a6-c6ec-4376-a88d-2da1608b0a7e',
}

export const getRandomEventCover = () => {
	const fileIds = Object.values(EventCoversEnum);
	const randomIndex = Math.floor(Math.random() * fileIds.length);

	return fileIds[randomIndex];
};

export const EventCoverS3Keys = {
	Image1: 'static_media/img-placeholder-1.png',
	Image2: 'static_media/img-placeholder-2.png',
	Image3: 'static_media/img-placeholder-3.png',
	Image4: 'static_media/img-placeholder-4.png',
	Image5: 'static_media/img-placeholder-5.png',
	Image6: 'static_media/img-placeholder-6.png',
	Image7: 'static_media/img-placeholder-7.png',
	Image8: 'static_media/img-placeholder-8.png',
};
